/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import classNames from "classnames";
import { FC, ReactNode } from "react";

type Props = {
  as?: keyof JSX.IntrinsicElements
  children: ReactNode
  className?: string
  [key: string]: any
} 

const Text: FC<Props> = ({ as, children, className, ...rest}) => {
  const Component = as || 'p';
  return (
    <Component className={classNames(className)} {...rest}>
      {children}
    </Component>
  );
}
export default Text;